import { isValidItalianVatNumber } from '@console/shared-kernel';
import { taxCodeProblem } from '@/profile/tax-code';

/**
 * The checks of the organization's VAT number and tax code, on the field while typing (U10). The
 * same rules as core-api's `OrganizationDetailsService`, which stays the one that decides
 * (`VAT_NUMBER_INVALID`, `TAX_CODE_INVALID`).
 */

const ITALY = 'IT';

/** Whether eleven digits are a valid «partita IVA»: the same check as the servers'. */
export { isValidItalianVatNumber } from '@console/shared-kernel';

/** As the server keeps it: no spaces, dots or dashes, upper case, an Italian «IT» prefix dropped. */
export function normalizeVatNumber(value: string, country: string): string {
  const compact = value.replace(/[\s.-]/g, '').toUpperCase();
  return country === ITALY && compact.startsWith(ITALY) ? compact.slice(ITALY.length) : compact;
}

export function normalizeTaxCode(value: string): string {
  return value.replace(/\s/g, '').toUpperCase();
}

export function vatNumberIsValid(value: string, country: string): boolean {
  const normalized = normalizeVatNumber(value, country);
  return country === ITALY
    ? isValidItalianVatNumber(normalized)
    : /^[A-Z0-9]{2,20}$/.test(normalized);
}

export function taxCodeIsValid(value: string, country: string): boolean {
  const normalized = normalizeTaxCode(value);
  return country === ITALY
    ? isValidItalianVatNumber(normalized) || taxCodeProblem(normalized) === null
    : /^[A-Z0-9./-]{2,32}$/.test(normalized);
}
